import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class CallHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.call_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.call_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.call_new, (call_id: number) => {
            this.broadcast(SharedEventNameEnum.call_new, { call_id });
        });
    };
}
